import React from "react";
import { useScroll } from "../context/UseContextScroll";
import { SvgIcon } from "../pages/Home/styled";

function Icon() {
  const { scroll } = useScroll();
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="39"
      fill="none"
      viewBox="0 0 39 39"
      moderno="true"
      scroll={scroll}
    >
      <path
        fill="#A71B38"
        d="M6.912 30.23a.82.82 0 00-.86-.87h-3.46a.81.81 0 01-.86-.86V11.23a.82.82 0 00-.87-.87.82.82 0 00-.86.87V28.5a2.54 2.54 0 002.59 2.59h3.46a.81.81 0 00.86-.86zM3.452 4.32a.87.87 0 10.87-.87.86.86 0 00-.87.87zM6.052 4.32a.86.86 0 10.86-.87.85.85 0 00-.86.87zM8.642 4.32a.86.86 0 10.86-.87.85.85 0 00-.86.87zM26.582 8.64h6.26a.82.82 0 00.87-.87.82.82 0 00-.87-.86h-6.26a.81.81 0 00-.86.86.819.819 0 00.86.87z"
      ></path>
      <path
        fill="#A71B38"
        d="M35.412 0H2.592a2.54 2.54 0 00-2.59 2.59v5.18a.82.82 0 00.86.87h10.47a.82.82 0 00.86-.87.811.811 0 00-.86-.86h-9.6V2.59a.81.81 0 01.86-.86h32.82a.81.81 0 01.86.86V28.5a.811.811 0 01-.86.86h-3.41a.87.87 0 000 1.73h3.46a2.54 2.54 0 002.54-2.59V2.59A2.541 2.541 0 0035.412 0zM28.192 33.44a3.38 3.38 0 00-.94.13 3 3 0 00-2.59-1.57 2.939 2.939 0 00-2.38 1.19 5.12 5.12 0 00-6.56 0 2.94 2.94 0 00-3.883-.768 3 3 0 00-1.087 1.119 3.38 3.38 0 00-.94-.13 3.68 3.68 0 00-3.68 3.67.85.85 0 001.7 0 2 2 0 012-2 2 2 0 011 .29.84.84 0 001.27-.61 1.28 1.28 0 011.25-1.09 1.26 1.26 0 011.26 1.16.84.84 0 00.64.74c.07.01.14.01.21 0a.86.86 0 00.71-.38 3.36 3.36 0 012.83-1.47 3.41 3.41 0 012.85 1.55.83.83 0 00.7.38c.07.01.14.01.21 0a.84.84 0 00.64-.74 1.26 1.26 0 011.26-1.16 1.28 1.28 0 011.25 1.09.84.84 0 001.27.61 2 2 0 011-.29 2 2 0 012 2 .85.85 0 101.7 0 3.68 3.68 0 00-3.69-3.72z"
      ></path>
      <path
        fill="#A71B38"
        d="M22.002 15.2a3 3 0 10-6.001 0 3 3 0 006 0zm-1.7 0a1.28 1.28 0 11-2.55-.226 1.28 1.28 0 012.55.226zM18.152 24.39v5.66a.85.85 0 001.7 0v-5.66a.85.85 0 10-1.7 0z"
      ></path>
      <path
        fill="#A71B38"
        d="M19.652 4.05a.86.86 0 00-.65-.29.85.85 0 00-.65.29l-3.49 4.19a7 7 0 00-1.65 4.84v7.07a3.17 3.17 0 01-1 2.2 6.81 6.81 0 00-1.82 4.87v1.41a.85.85 0 00.84.85h2v.57a.84.84 0 00.84.84.85.85 0 00.85-.84v-.57h1.27a.85.85 0 100-1.69h-4.1v-.57a5.119 5.119 0 011.43-3.79 4.74 4.74 0 001.39-3.27v-7.08a5.45 5.45 0 011.21-3.7l2.88-3.46 2.92 3.5a5.34 5.34 0 011.17 3.65v7.07a4.76 4.76 0 001.4 3.28 5.139 5.139 0 011.43 3.79v.57h-4.1a.85.85 0 100 1.69h1.28v.57a.85.85 0 001.7 0v-.57h2a.85.85 0 00.84-.85v-1.4a6.81 6.81 0 00-1.81-4.87 3.15 3.15 0 01-1-2.2v-7.07a7.09 7.09 0 00-1.61-4.79l-3.57-4.24z"
      ></path>
    </SvgIcon>
  );
}

export default Icon;
